let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6KBsT")).then(() => parcelRequire('6pPz6'));